import React, { useState, useEffect } from 'react';
import Light from './headers/light';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import ProductTabs from "./cards/TabCardGrid2"; // TabCardGrid2 = ProductTabs
import LightAdmin from './headers/lightAdmin';
import { useTranslation } from 'react-i18next';
import Footerr from './footers/Footer';
import { Helmet } from 'react-helmet-async';

const Boutique = () => {
  const [role, setRole] = useState('');
  const [cart, setCart] = useState([]);
  const [products, setProducts] = useState([]);
  const { i18n } = useTranslation();

  useEffect(() => {
    const userRole = localStorage.getItem('role');
    setRole(userRole);
    const fetchProducts = async () => {
      try {
        const res1 = await fetch(`https://rehabwmg.online/api/products?lang=${i18n.language}`);
        const data = await res1.json();
        setProducts(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erreur lors du chargement des produits :", error);
      }
    };

    fetchProducts();
  }, [i18n.language]);

  const handleAddToCart = (product) => {
    const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
    const found = existingCart.find(item => item.productID === product.ProductID);

    if (found) {
      found.quantity += 1;
    } else {
      existingCart.push({
        productID: product.ProductID,
        productName: product.Name,
        productImage: product.image,
        productPrice: role === "supplier" ? product.distributeur_price : product.user_price,
        quantity: 1
      });
    }
    localStorage.setItem('cart', JSON.stringify(existingCart));
    setCart(existingCart);
    alert("Produit ajouté au panier !");
  };

  return (
    <>
      <Helmet>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
        <title>Boutique - Cosmétiques Bio & Compléments | Rehab Bio</title>
        <meta name="description" content="Découvrez notre collection de produits cosmétiques 100% naturels et compléments alimentaires. Achetez en ligne avec livraison gratuite partout au Maroc." />
        <meta name="theme-color" content="#1b5e20" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://rehabbio.ma/Boutique" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rehabbio.ma/Boutique" />
        <meta property="og:title" content="Boutique - Cosmétiques Bio & Compléments | Rehab Bio" />
        <meta property="og:description" content="Découvrez notre collection de produits cosmétiques 100% naturels et compléments alimentaires. Achetez en ligne avec livraison gratuite partout au Maroc." />
        <meta property="og:image" content="https://rehabbio.ma/images/og-image.jpg" />
        <meta property="og:site_name" content="Rehab Bio Cosmetics" />
        <meta property="og:locale" content="fr_MA" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://rehabbio.ma/Boutique" />
        <meta name="twitter:title" content="Boutique - Cosmétiques Bio & Compléments | Rehab Bio" />
        <meta name="twitter:description" content="Découvrez notre collection de produits cosmétiques 100% naturels et compléments alimentaires. Achetez en ligne avec livraison gratuite partout au Maroc." />
        <meta name="twitter:image" content="https://rehabbio.ma/images/og-image.jpg" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "CollectionPage",
              "name": "Boutique Rehab Bio Cosmetics",
              "url": "https://rehabbio.ma/Boutique",
              "description": "Boutique en ligne officielle de Rehab Bio Cosmetics. Produits naturels pour la peau, les cheveux et compléments alimentaires.",
              "mainEntity": {
                "@type": "ItemList",
                "itemListElement": [
                  { "@type": "ListItem", "position": 1, "name": "Cosmétiques" },
                  { "@type": "ListItem", "position": 2, "name": "Compléments Alimentaires" },
                  { "@type": "ListItem", "position": 3, "name": "Shampoings" },
                  { "@type": "ListItem", "position": 4, "name": "Packs" }
                ]
              }
            }
          `}
        </script>

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Accueil",
                  "item": "https://rehabbio.ma/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Boutique",
                  "item": "https://rehabbio.ma/Boutique"
                }
              ]
            }
          `}
        </script>
      </Helmet>

      <AnimationRevealPage>
        {role === 'supplier' ? <Light /> : role === 'admin' ? <LightAdmin /> : <Light />}
        <ProductTabs
          heading=""
          products={products}
          role={role}
          onAddToCart={handleAddToCart}
        />
        <Footerr />
      </AnimationRevealPage>
    </>
  );
};

export default Boutique;